module.exports = __webpack_public_path__ + "static/media/Portuguese_Brazillian_Simone BG-10.c331f9fa.png";